// MySchedule.js
import React, { useState } from 'react';
import './MySchedule.css';
import LiveSchedule from './LiveSchedule';
import DemoAvailability from './DemoAvailability';
import PaidAvailability from './PaidAvailability';

const MySchedule = ({ userData }) => {
  const [activeTab, setActiveTab] = useState('schedule');
  const [isLoading, setIsLoading] = useState(false);
console.log(userData);
  if (isLoading || !userData) {
    return (
      <div className="teacher-dashboard">
        <div className="teacher-dashboard__loading-container">
          <div className="teacher-dashboard__loading-spinner"></div>
          <p>Loading your Schedule...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="my-classes">
      <header className="my-classes__header">
        <div className="my-classes__header-content">
          <h1>
            Welcome back, <span>{userData.fullName}</span>
          </h1>
          <p className="my-classes__subheader">This is Your Schedule</p>
        </div>
      </header>

      <div className="schedule-tabs">
        <button
          className={`schedule-tab ${activeTab === 'schedule' ? 'active' : ''}`}
          onClick={() => setActiveTab('schedule')}
        >
          Live Schedule
        </button>
        <button
          className={`schedule-tab ${activeTab === 'demo' ? 'active' : ''}`}
          onClick={() => setActiveTab('demo')}
        >
          Demo Availability
        </button>
        <button
          className={`schedule-tab ${activeTab === 'paid' ? 'active' : ''}`}
          onClick={() => setActiveTab('paid')}
        >
          Paid Availability
        </button>
      </div>
      
      <div className="schedule-content">
        {activeTab === 'schedule' && <LiveSchedule userData={userData} />}
        {activeTab === 'demo' && <DemoAvailability userData={userData} />}
        {activeTab === 'paid' && <PaidAvailability userData={userData} />}
      </div>
    </div>
  );
};

export default MySchedule;